import { API_HOST } from 'src/redux/constants';

// Not published in window.djconfig.APIS, so the paths are built from API_HOST.
const AI_BASE = `${API_HOST}/ai`;

export const AI_PROMPT_TEMPLATES_URL = `${AI_BASE}/prompt-templates/`;

// The trailing slash is required: /ai/prompt redirects and a POST loses its body.
export const AI_PROMPT_URL = `${AI_BASE}/prompt/`;

export const AI_PROMPT_STATUS_URL = `${AI_BASE}/prompt/status/`;

// A job stuck in pending must fail rather than keep the editor locked.
export const AI_POLL_INTERVAL_MS = 3500;

export const AI_POLL_TIMEOUT_MS = 40000;

export const AI_POLL_MAX_ATTEMPTS = Math.ceil(
  AI_POLL_TIMEOUT_MS / AI_POLL_INTERVAL_MS,
);

export const AI_TEMPLATES_TOAST_ID = 'ai-prompt-templates-error';
